import { render, staticRenderFns } from "./ImportacoesQuestoes.vue?vue&type=template&id=76b22d9c&scoped=true"
import script from "./ImportacoesQuestoes.vue?vue&type=script&lang=js"
export * from "./ImportacoesQuestoes.vue?vue&type=script&lang=js"
import style0 from "./ImportacoesQuestoes.vue?vue&type=style&index=0&id=76b22d9c&prod&lang=scss&scoped=true"
import style1 from "./ImportacoesQuestoes.vue?vue&type=style&index=1&id=76b22d9c&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "76b22d9c",
  null
  
)

export default component.exports